module.exports = __webpack_public_path__ + "img/011  Program Statistics-Solid.300498ff.svg";